import React, { Component } from 'react';
import $ from 'jquery';
import { getMainCookie } from '../../../util/util';
import MenuBar from '../../components/MenuBar/MenuBar'
import  './css/Report.css';
import './js/Report'
import SideBarAdmin from '../../components/AdminConfig/SideBarAdmin';
import SideBarToggle from '../../components/AdminConfig/Content/SideBarToggle';
import ReportPortal from '../../components/Report/ReportPortal';
import ReportSummaryByGroup from "../../components/Report/ReportSummaryByGroup";
import ReportUsageSummary from "../../components/Report/ReportUsageSummary";
import GraphSpeed from '../../components/Report/GraphSpeed';
import GraphHeat from '../../components/Report/GraphHeat';

import ReportEventAlert from '../../components/Report/ReportEventAlert'
import ReportWorkingHours from '../../components/Report/ReportWorkingHours';
import ReportRFID from '../../components/Report/ReportRFID';
import ReportPoiInOut from '../../components/Report/ReportPoiInOut';
import ReportRoute from '../../components/Report/ReportRoute';
import ReportDistance from "../../components/Report/ReportDistance";
import ReportStop from "../../components/Report/ReportStop";
import GraphFuel from '../../components/Report/GraphFuel';
import { withNamespaces } from 'react-i18next';
import ReportSummary from '../../components/Report/ReportSummary';

class Report extends Component {

    constructor() {
        super();

        this.state = {
            isReportTap: true,
            isClickReportPortal: true,
            isClickGraphSpeed:false,
            isClickGraphHeat:false,
            isClickGraphFuel:false,
            isClickReportSummaryByGroup: false,
            isClickReportUsageSummary: false,
            isClickReportWorkingHours: false, //(ชั่วโมงการทำงาน)
            isClickReportEventAlert:false, // (รายงานการแจ้งเตือน)
            isClickReportRoute: false, //(รายงานเส้นทางการวิ่ง)
            isClickReportDistance: false,    //(รายงานระยะทางการวิ่ง)
            isClickReportStop: false, //(รายงานการจอด)
            isClickReportRFID: false, //(รายงานการรูดบัตร)
            isClickReportPoiInOut: false, //(เข้า-ออก POI)
            isClickReportSummary: false,
        };

    }

    componentWillMount() {
        const cookieObj = getMainCookie();
        this.setState({
            userLevel: cookieObj.user_level,
            user_name: cookieObj.login_name,
            user_id: cookieObj.user_id,
            token: cookieObj.token
        });
    }

    componentDidMount() {
        $('#sidebar').toggleClass('active');
        $('#sidebarAdminCollapse').on('click', function () {
            $('#sidebar').toggleClass('active');

            for(let i=0;i<$('#adminSidebar>li').length;i++){
                if($('#adminSidebar>li')[i].className.indexOf('menumini')>-1)
                    $('#adminSidebar>li')[i].className="";
                else
                    $('#adminSidebar>li')[i].className="menumini";
            }

        });
        this.setListClick();
    }

    componentDidUpdate(){
        this.setListClick();

    }

    componentWillUnmount() {
        this.setState({
            isReportTap: false,
            isClickReportPortal: true,
            isClickReportSummaryByGroup: false
        });
    }

    setListClick(){
        $('.list-unstyled li').click(function(e) {
            e.preventDefault()

            let that = $(this);

            that.parent().parent().parent().parent().find('li').removeClass('sub-active');
            that.addClass('sub-active');

            if(that.parent().parent().parent()[0].className.indexOf('menumini')>-1){
                that.parent().removeClass('show');
                that.parent().parent().parent().parent().parent().find('a').attr("aria-expanded","false");
                that.parent().parent().parent().find('.dropdown-toggle').attr("aria-expanded","true")

            }

        });
    }

    onClickSideBar = (sideBarName) => {
        console.log('sideBarName:', sideBarName);
        if (sideBarName === 'reportPortal') {
            this.setState({
               sideBarName,
               isClickReportPortal: true,
               isClickReportSummaryByGroup: false,
               isClickGraphSpeed:false,
               isClickGraphHeat:false,
               isClickGraphFuel:false,
               isClickReportUsageSummary: false,
               isClickReportWorkingHours: false, //(ชั่วโมงการทำงาน)
               isClickReportEventAlert:false, // (รายงานการแจ้งเตือน)
               isClickReportRoute: false, //(รายงานเส้นทางการวิ่ง)
               isClickReportDistance: false,    //(รายงานระยะทางการวิ่ง)
               isClickReportStop: false, //(รายงานการจอด)
               isClickReportRFID: false, //(รายงานการรูดบัตร)
               isClickReportPoiInOut: false, //(เข้า-ออก POI)
               isClickReportSummary:false
            });
        }
    }

    gotoReport = (reportName) => {
        console.log('gotoReport reportName:', reportName);
        if (reportName === 'reportSummaryByGroup') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: true,
                isClickReportUsageSummary:false,
                isClickGraphSpeed:false,
                isClickGraphHeat:false,
                isClickGraphFuel:false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportUsageSummary') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary:true,
                isClickGraphSpeed:false,
                isClickGraphHeat:false,
                isClickGraphFuel:false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'GraphSpeed') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary:false,
                isClickGraphSpeed:true,
                isClickGraphHeat:false,
                isClickGraphFuel:false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'GraphFuel') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary:false,
                isClickGraphSpeed:false,
                isClickGraphHeat:false,
                isClickGraphFuel:true,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'GraphHeat') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary:false,
                isClickGraphSpeed:false,
                isClickGraphHeat:true,
                isClickGraphFuel:false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportWorkingHours') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: true,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportEventAlert') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: true,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportPoiInOut') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: true,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportRFID') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: true,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportRoute') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: true,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportDistance') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: true,
                isClickReportStop: false,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportStop') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: true,
                isClickReportSummary:false
            })
        }
        if (reportName === 'reportSummary') {
            this.setState({
                isClickReportPortal: false,
                isClickReportSummaryByGroup: false,
                isClickReportUsageSummary: false,
                isClickReportWorkingHours: false,
                isClickReportEventAlert: false,
                isClickReportRFID: false,
                isClickReportPoiInOut: false,
                isClickReportRoute: false,
                isClickReportDistance: false,
                isClickReportStop: false,
                isClickReportSummary:true
            })
        }

        }
        

    onClickBackToReportPortal = () => {
        this.setState({
            isClickReportPortal: true,
            isClickReportSummaryByGroup: false,
            isClickReportUsageSummary:false,
            isClickReportWorkingHours: false,
            isClickReportEventAlert: false,
            isClickReportRFID: false,
            isClickReportPoiInOut: false,
            isClickReportRoute: false,
            isClickReportDistance: false,
            isClickReportStop: false,
            isClickReportSummary:false
        })
    }

        render() {
        const { t } = this.props;
        const {
            userLevel,
            user_name,
            user_id,
            token,
            isReportTap,
            isClickReportPortal,
            isClickReportSummaryByGroup,
            isClickReportUsageSummary,
            isClickGraphSpeed,
            isClickGraphHeat,
            isClickGraphFuel,
            isClickReportWorkingHours,
            isClickReportEventAlert,
            isClickReportRFID,
            isClickReportPoiInOut,
            isClickReportRoute,
            isClickReportDistance,
            isClickReportStop,
            isClickReportSummary
        } = this.state;
        console.log('reportNameList:', this.state.reportNameList);
    return (
      <div style={{marginTop: 50}}>
          <MenuBar tab_report="active"/>
          <div className="wrapper">
              <nav id="sidebar">
                  <SideBarAdmin
                      isReportTap={isReportTap}
                      onClickSideBar={this.onClickSideBar}
                      userLevel={userLevel}
                  />
              </nav>
              <div id="content" style={{overflowX:"auto"}}>
                  <SideBarToggle/>
                  {isClickReportPortal &&
                    <ReportPortal
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        gotoReport={(data) => this.gotoReport(data)}
                    />
                  }
                  {isClickReportSummaryByGroup &&
                    <ReportSummaryByGroup
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true, isClickReportSummaryByGroup: false})}
                    />
                  }
                  {
                      isClickReportSummary &&
                      <ReportSummary
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true, isClickReportSummary: false})}
                      />
                  }
                  {isClickReportUsageSummary &&
                      <ReportUsageSummary
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true,ReportUsageSummary: false})}
                        />
                    }
                    {
                      isClickGraphSpeed &&
                      <GraphSpeed
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true, isClickGraphSpeed: false})}
                        />
                    }
                    {
                      isClickGraphHeat &&
                      <GraphHeat
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true, isClickGraphHeat: false})}
                        />
                    }
                    {
                      isClickGraphFuel &&
                      <GraphFuel
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true, isClickGraphFuel: false})}
                        />
                    }
                    {
                      isClickReportWorkingHours &&
                      <ReportWorkingHours
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.setState({isClickReportPortal: true, isClickReportWorkingHours: false})}
                        />
                    }

                  {isClickReportEventAlert &&
                      <ReportEventAlert
                          t={t}
                          userLevel={userLevel}
                          user_name={user_name}
                          user_id={user_id}
                          token={token}
                          onClickBackToReportPortal={() => this.onClickBackToReportPortal()}
                      />
                  }

                  {
                    isClickReportRFID &&
                    <ReportRFID
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.onClickBackToReportPortal()}
                    />
                  }

                  {
                    isClickReportPoiInOut &&
                    <ReportPoiInOut
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.onClickBackToReportPortal()}
                    />
                  }
                  {
                    isClickReportRoute &&
                    <ReportRoute
                        t={t}
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        onClickBackToReportPortal={() => this.onClickBackToReportPortal()}
                    />
                  }
                  {
                     isClickReportDistance &&
                      <ReportDistance
                          t={t}
                          userLevel={userLevel}
                          user_name={user_name}
                          user_id={user_id}
                          token={token}
                          onClickBackToReportPortal={() => this.onClickBackToReportPortal()}
                      />
                  }
                  {
                      isClickReportStop &&
                      <ReportStop
                          t={t}
                          userLevel={userLevel}
                          user_name={user_name}
                          user_id={user_id}
                          token={token}
                          onClickBackToReportPortal={() => this.onClickBackToReportPortal()}
                      />
                  }
              </div>
          </div>
      </div>
    );
  }
 }

export default withNamespaces('Menubar')(Report);



// WEBPACK FOOTER //
// ./src/app/view/containers/Report/Report.js